__turbopack_context__.v({
  "desktopOnly": "index-module__R-q55G__desktopOnly",
  "mobileOnly": "index-module__R-q55G__mobileOnly",
  "root": "index-module__R-q55G__root",
});
